import { IMvpInventory } from '@/coreDomainsModule/entities/inventory';
import { IUnmanagedBusiness } from '@/coreDomainsModule/entities/unmanagedBusiness';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IUnmanagedBusinessRepository } from '@/coreInfrastructureModule/interfaces/IUnmanagedBusinessRepository';

/**
 * 未管理の取引を保存するユースケース
 */
export class BulkSaveUnmanagedBusinessUseCase {
  private repository: IUnmanagedBusinessRepository;

  /**
   * コンストラクタ
   * @param repository - 未管理の取引の永続化の責務を負うクラス
   */
  constructor(repository: IUnmanagedBusinessRepository) {
    this.repository = repository;
  }

  /**
   * 未管理の取引を保存する
   * @param businesses - 未管理の取引
   */
  public execute(businesses: IUnmanagedBusiness[]): INetworkResult<void, Error> {
    try {
      // NOTE: 同様の列の場合、数値情報は加算して保存する（https://github.com/lean-path1201/leanpath/issues/2156で追加）
      const businessMap: { [key: string]: IUnmanagedBusiness } = {};
      businesses.forEach((business) => {
        const key = `${business.fileName}-${business.warehouseNumber}-${business.package}-${business.businessNumber}-${business.supplierNumber}-${business.customerNumber}-${business.salesDestinationNumber}`;
        // 同じ内容の取引については、2回目以降は無視する（合算処理は転記の際に行なっているので問題ない）
        if (!businessMap[key]) {
          if (business.inventories) {
            // 在庫だけ、合算処理ができていないのでここで合算する（他に関しては、すでに合算済みなので何もしていない）
            const inventoryMap: { [key: string]: IMvpInventory } = {};
            business.inventories.forEach((inventory) => {
              const inventoryKey = `${inventory.year}-${inventory.month}`;
              if (inventoryMap[inventoryKey]) {
                inventoryMap[inventoryKey].amount += inventory.amount;
              } else {
                inventoryMap[inventoryKey] = { ...inventory };
              }
            });
            business.inventories = Object.values(inventoryMap);
            business.inventory = business.inventories.reduce((acc, inventory) => acc + inventory.amount, 0);
          }
          businessMap[key] = { ...business };
        }
      });
      businesses = Object.values(businessMap);

      return this.repository.bulkSave(businesses);
    } catch (error) {
      console.error(error);
      return {
        status: {
          type: 'error',
          error: Error('想定外のエラーが発生しました'),
        },
      }; // 基本的にはここには到達しないはず
    }
  }
}
